import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Shield, RefreshCw, GitMerge, UserCheck, MessageSquare, Moon } from 'lucide-react';
export function ModulesSection() {
  const modules = [{
    icon: <Shield className="w-6 h-6 text-brand-gold" data-id="element-105" />,
    title: 'Módulo 1: El Apagón Digital',
    description: 'Cómo hacerte invisible y recuperar tu poder en las primeras 168 horas.'
  }, {
    icon: <RefreshCw className="w-6 h-6 text-brand-gold" data-id="element-106" />,
    title: 'Módulo 2: Reconfiguración del Algoritmo',
    description: 'Técnicas para detener la rumiación y los pensamientos intrusivos.'
  }, {
    icon: <GitMerge className="w-6 h-6 text-brand-gold" data-id="element-107" />,
    title: 'Módulo 3: El Muro de Contención',
    description: 'El árbol de decisiones exacto para saber cuándo responder, cuándo callar y qué decir.'
  }, {
    icon: <UserCheck className="w-6 h-6 text-brand-gold" data-id="element-108" />,
    title: 'Módulo 4: Identidad Nueva',
    description: 'Cómo dejar de ser "la ex de..." para volver a ser el dueño/a de tu vida.'
  }, {
    icon: <MessageSquare className="w-6 h-6 text-brand-gold" data-id="element-109" />,
    title: 'Guiones de Poder',
    description: 'Frases listas para copiar y pegar ante mensajes nostálgicos, logísticos o provocaciones.'
  }, {
    icon: <Moon className="w-6 h-6 text-brand-gold" data-id="element-110" />,
    title: 'Tracker de Impulsos Nocturnos',
    description: 'Una herramienta práctica para vencer la tentación de las 11 PM.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-24 relative pt-[20px] pb-[20px]" data-id="element-111">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-113">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="inline-flex items-center gap-3 bg-brand-gold/10 border border-brand-gold/30 rounded-full px-6 py-3 mb-6" data-id="element-114">
            <span className="text-brand-gray line-through text-lg" data-id="element-115">$19.99</span>
            <span className="text-3xl font-black text-brand-gold" data-id="element-116">$6.39</span>
            <span className="text-brand-white text-sm font-bold uppercase bg-brand-red px-3 py-1 rounded-full" data-id="element-117">
              -32%
            </span>
          </motion.div>

          <motion.a href="https://pay.hotmart.com/J105067242R" target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.98
        }} className="hover:bg-brand-gold/90 text-brand-black font-black uppercase px-8 py-4 rounded-xl text-lg mb-8 transition-all duration-300 box-glow-gold inline-block bg-[#FF0606]" data-id="element-118">
            quiero sanar
          </motion.a>

          <h2 className="text-3xl md:text-4xl font-black text-brand-white uppercase tracking-tight" data-id="element-119">
            Lo que vas a lograr con este programa
          </h2>
          <div className="w-24 h-1 bg-brand-gold mx-auto mt-6 rounded-full opacity-50" data-id="element-120" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-121">
          {modules.map((mod, index) => <motion.div key={index} variants={itemVariants} className="bg-brand-dark p-8 rounded-2xl border border-white/5 hover:border-brand-gold/30 transition-all duration-300 group pt-[32px] pb-[32px]" data-id="element-122">
              <div className="w-12 h-12 rounded-xl bg-brand-black border border-white/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-123">
                {mod.icon}
              </div>
              <h3 className="text-xl font-bold text-brand-white mb-3" data-id="element-124">
                {mod.title}
              </h3>
              <p className="text-brand-gray leading-relaxed" data-id="element-125">
                {mod.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}